import { SectionPageCollection } from '../../interfaces';
import { PaperworkFieldName } from '../../paperworkConstants';

export enum VerificationAndReviewPageNumber {
  PageOne,
}

export const VERIFICATION_AND_REVIEW_PAGES: SectionPageCollection = new Map([
  [
    VerificationAndReviewPageNumber.PageOne,
    {
      fieldNames: [PaperworkFieldName.REASON_FOR_VISIT],
    },
  ],
]);
